export function triggerEvent(el: Element, type: string): void{
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, false, true);
  el.dispatchEvent(e);
}
